import { render, staticRenderFns } from "./Publications.vue?vue&type=template&id=7a81fd1b&scoped=true"
import script from "./Publications.vue?vue&type=script&setup=true&lang=js"
export * from "./Publications.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a81fd1b",
  null
  
)

export default component.exports